import { getUuidV4 } from '../../../utilities/random';
/**
 * Kind of events used to communicate between content and container component.
 */
export var CommunicationsEventKind;
(function (CommunicationsEventKind) {
    CommunicationsEventKind["Mounted"] = "mounted";
    CommunicationsEventKind["BeforeUpdate"] = "beforeUpdate";
    CommunicationsEventKind["Updated"] = "updated";
    CommunicationsEventKind["BeforeDispose"] = "beforeDispose";
    CommunicationsEventKind["Disposed"] = "disposed";
    CommunicationsEventKind["Data"] = "data";
})(CommunicationsEventKind || (CommunicationsEventKind = {}));
/**
 * Event used to communicate between content and container component.
 */
var CommunicationsEvent = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param kind The kind of event.
     */
    function CommunicationsEvent(kind) {
        this.kind = kind;
        this.uuid = getUuidV4();
        this.timestamp = new Date().getTime();
        this.contentId = '';
    }
    /**
     * The type of event dispatched by the child component.
     */
    CommunicationsEvent.CONTENT_EVENT_TYPE = 'content_event.communication.children.validide_micro_front_ends';
    /**
     * The type of event dispatched by the content.
     */
    CommunicationsEvent.CONTAINER_EVENT_TYPE = 'container_event.communication.children.validide_micro_front_ends';
    return CommunicationsEvent;
}());
export { CommunicationsEvent };
//# sourceMappingURL=event.js.map